import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SelezionaPAModalComponent } from './seleziona-pa-modal';

export const SelezionaPAModalModule: string = ng
    .module('seleziona-pa-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('selezionaPAModalComponent', SelezionaPAModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/seleziona-pa-modal/seleziona-pa-modal.module.ts